export const term = {
    labels: {
        term: "Termo",
        terms: "Terms",
        add_term: "Adicionar Termo",
        delete_term: "Deletar Termo",
    },
    placeholders: {
    },
    modals: {
        titles: {
            term_remove: "Remover Termo",
        },
        messages: {
            term_remove: "Você deseja mesmo remover o termo <strong>{name}</strong>?<br/>Esta ação não pode ser desfeita.",
        }
    },
    texts: {
        empty: "Não há termos para exibir",
        add_term: "Você deseja adicionar um termo para este item?",
        delete_term: "Você deseja deletar este termo?<br/>Esta ação não pode ser desfeita.",
    },
};
